module.exports = __webpack_public_path__ + "img/thirteenimg3.dd1f2e52.png";